var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wtw-container full-max-width-minus-two colors-container" },
    _vm._l(_vm.rowCount, function(i) {
      return _c(
        "div",
        { staticClass: "row clearfix" },
        _vm._l(_vm.optionCountInRow(i), function(option, index) {
          return _c(
            "div",
            {
              staticClass: "color-option",
              class: {
                active:
                  _vm.optionActive(option.product_option_value_id) ||
                  _vm.allActive,
                clearfix: (index + 1) % 3 == 0
              },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.toggleOption(option.product_option_value_id)
                }
              }
            },
            [
              _c("img", {
                attrs: { src: option.product_option_value_image_url }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "cross" }),
              _vm._v(" "),
              _c("div", { staticClass: "color-option-text" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(option.product_option_value_title) +
                    "\n            "
                )
              ])
            ]
          )
        }),
        0
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ad67e1d2", { render: render, staticRenderFns: staticRenderFns })
  }
}